export class FieldsSectionOptions {
	appendPath: boolean;

	constructor() {
		this.appendPath = true;
	}
}
